"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react2 = _interopRequireDefault(require("@tippyjs/react"));

var _deepExtend = _interopRequireDefault(require("deep-extend"));

var Styled = (0, _styledComponents["default"])(_react2["default"]).withConfig({
  displayName: "StyledTippy__Styled",
  componentId: "sc-9z7huw-0"
})(function (_ref) {
  var theme = _ref.theme;
  return (0, _deepExtend["default"])({}, {
    minWidth: "125px",
    ".tippy-content": {
      boxSizing: "border-box",
      backgroundColor: "#1c273a",
      padding: "10px 8px",
      fontSize: "12px",
      lineHeight: "12px",
      textAlign: "center",
      boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
      color: "white",
      fontWeight: 700,
      borderRadius: "4px !important"
    }
  }, theme.tooltip);
});

var StyledTippy = function StyledTippy(props) {
  return /*#__PURE__*/_react["default"].createElement(Styled, (0, _extends2["default"])({}, props, {
    className: "inbox--tooltip",
    offset: [0, 3]
  }));
};

var _default = StyledTippy;
exports["default"] = _default;